// number in currecy format
export function currency(numberValue, maximumFractionDigits = 0) {
  if (isNaN(numberValue)) return "";

  return (
    "৳ " +
    (numberValue || 0).toLocaleString("en-IN", {
      maximumFractionDigits
    })
  );
}

// number in kilometer
export function mileageKm(numberValue, maximumFractionDigits = 0) {
  return (
    (numberValue || 0)?.toLocaleString("en-IN", {
      maximumFractionDigits
    }) + "Km"
  );
}

// number to word
export function convertNumberToWords(amount) {
  const units = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine"];
  const tens = [
    "",
    "Ten",
    "Twenty",
    "Thirty",
    "Forty",
    "Fifty",
    "Sixty",
    "Seventy",
    "Eighty",
    "Ninety"
  ];
  const teens = [
    "Ten",
    "Eleven",
    "Twelve",
    "Thirteen",
    "Fourteen",
    "Fifteen",
    "Sixteen",
    "Seventeen",
    "Eighteen",
    "Nineteen"
  ];

  const zero = "Zero";
  const arab = "Arab";
  const crore = "Crore";
  const lakh = "Lakh";
  const thousand = "Thousand";
  const hundred = "Hundred";
  const currencyBDT = "Taka";
  const paisa = "Paisa";
  const only = "Only";
  const negative = "(Refundable)";

  if (amount === 0) return `${zero} ${currencyBDT} ${only}`;

  let isNegative = amount < 0;
  if (isNegative) {
    amount = Math.abs(amount);
  }

  function convert(num) {
    let parts = [];
    if (num >= 1e9) {
      parts.push(`${convert(Math.floor(num / 1e9))} ${arab}`);
      num %= 1e9;
    }
    if (num >= 1e7) {
      parts.push(`${convert(Math.floor(num / 1e7))} ${crore}`);
      num %= 1e7;
    }
    if (num >= 1e5) {
      parts.push(`${convert(Math.floor(num / 1e5))} ${lakh}`);
      num %= 1e5;
    }
    if (num >= 1000) {
      parts.push(`${convert(Math.floor(num / 1000))} ${thousand}`);
      num %= 1000;
    }
    if (num >= 100) {
      parts.push(`${convert(Math.floor(num / 100))} ${hundred}`);
      num %= 100;
    }
    if (num >= 20) {
      parts.push(`${tens[Math.floor(num / 10)]}`);
      if (num % 10 > 0) parts.push(units[num % 10]);
    } else if (num >= 10) {
      parts.push(teens[num - 10]);
    } else if (num > 0) {
      parts.push(units[num]);
    }
    return parts.join(" ");
  }

  let integerPart = Math.floor(amount);
  let wholeWordPart = convert(integerPart);
  let result = wholeWordPart ? `${wholeWordPart} ${currencyBDT}` : "";

  let decimalPart = Math.round((amount - integerPart) * 100);
  if (decimalPart > 0) {
    if (wholeWordPart) {
      result += " and ";
    }
    result += `${convert(decimalPart)} ${paisa}`;
  }

  return `${result} ${only} ${isNegative ? negative : ""}`;
}

// display only number
export function displayNumber(numberValue, maximumFractionDigits = 0) {
  if (isNaN(numberValue)) return "";
  return numberValue.toLocaleString("en-IN", {
    maximumFractionDigits
  });
}

// mobile number format for only 11 digit
export function formatMobileNumber(mobileNumber) {
  // Convert the mobile number to a string
  const numberStr = mobileNumber.toString();

  // Check if the number is 11 digits long
  if (numberStr.length === 11) {
    // Add the country code +88 and format as (+88) 01303-766-837
    return `(+88) ${numberStr.slice(0, 5)}-${numberStr.slice(5, 8)}-${numberStr.slice(8)}`;
  } else {
    // Return the number as is
    return numberStr;
  }
}

// get random number
export function getRandomNumber(min = 40, max = 100) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}
